import React from "react";
import { useNavigate } from "react-router-dom";
import { usePublicLanguage } from "../../context/PublicLanguage";
export default function LanguageSwitcher() {
  const { language, setLanguage, articleRoutes, t } = usePublicLanguage();
  const navigate = useNavigate();
  const select = (value) => {
    if (articleRoutes && !articleRoutes[value]) return;
    setLanguage(value);
    if (articleRoutes?.[value]) navigate(articleRoutes[value]);
  };
  return <div role="group" aria-label={t("Language")} className="flex shrink-0 rounded-full border border-white/15 p-0.5" data-testid="language-switcher">
    {[["en", "English"], ["id", "Bahasa Indonesia"]].map(([value, label]) =>
      <button key={value} type="button" lang={value} aria-label={label} aria-pressed={language === value}
        disabled={Boolean(articleRoutes && !articleRoutes[value])}
        title={articleRoutes && !articleRoutes[value] ? "Terjemahan belum tersedia" : label}
        onClick={() => select(value)}
        className={`w-9 h-8 rounded-full text-xs font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#FF8A1F] ${language === value ? "bg-[#FF8A1F] text-[#08090A]" : "text-[#A7ABB0] hover:text-white"}`}>
        {value.toUpperCase()}
      </button>)}
  </div>;
}
